import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function CookieIcon({ color = "white" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.55426 6.38462C11.0518 4.58637 14.0089 4 16 4H17.3333C18.0697 4 18.6667 4.59695 18.6667 5.33333V9.33333H21.3333C22.0697 9.33333 22.6667 9.93029 22.6667 10.6667V13.3333H26.6667C27.403 13.3333 28 13.9303 28 14.6667V16C28 20.6679 26.1497 23.7418 23.6254 25.6059C21.1671 27.4213 18.1965 28 16 28C13.8035 28 10.8329 27.4213 8.37461 25.6059C5.85029 23.7418 4 20.6679 4 16C4 11.2988 5.98871 8.23182 8.55426 6.38462ZM10.6667 10.6667C10.6667 9.93029 11.2636 9.33333 12 9.33333H12.0133C12.7497 9.33333 13.3467 9.93029 13.3467 10.6667C13.3467 11.403 12.7497 12 12.0133 12H12C11.2636 12 10.6667 11.403 10.6667 10.6667ZM8 16C8 15.2636 8.59695 14.6667 9.33333 14.6667H9.34667C10.083 14.6667 10.68 15.2636 10.68 16C10.68 16.7364 10.083 17.3333 9.34667 17.3333H9.33333C8.59695 17.3333 8 16.7364 8 16ZM14.6667 17.3333C14.6667 16.597 15.2636 16 16 16H16.0133C16.7497 16 17.3467 16.597 17.3467 17.3333C17.3467 18.0697 16.7497 18.6667 16.0133 18.6667H16C15.2636 18.6667 14.6667 18.0697 14.6667 17.3333ZM20 20C20 19.2636 20.597 18.6667 21.3333 18.6667H21.3467C22.0831 18.6667 22.68 19.2636 22.68 20C22.68 20.7364 22.0831 21.3333 21.3467 21.3333H21.3333C20.597 21.3333 20 20.7364 20 20ZM12 21.3333C12 20.597 12.597 20 13.3333 20H13.3467C14.083 20 14.68 20.597 14.68 21.3333C14.68 22.0697 14.083 22.6667 13.3467 22.6667H13.3333C12.597 22.6667 12 22.0697 12 21.3333Z"
        fill="url(#paint0_linear_1126_23679)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1126_23679"
          x1="4"
          y1="4"
          x2="28"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0068FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
